
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError, timer } from 'rxjs';
import { catchError, count, filter, retry, switchMap, take } from 'rxjs/operators';

import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { TokenService } from './token.service';
import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable({
  providedIn: 'root'
})
export class AccessTokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  constructor(
    private tokenService: TokenService,
    private router: Router,
    private auth : AuthenticationService,
    private notifyService: NotifyService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if(req.url.includes('login') || req.url.includes('refresh') || req.url.includes('logout') || req.url.includes('viacep') || req.url.includes('ibge') || req.url.includes('pdf') || req.url.includes('password-reset')
    || req.url.includes('password-reset-complete')) {
      return next.handle(req);
    }
    const tokenizedReq = this.setHeaderToken(req);
    return next.handle(tokenizedReq).pipe(
      retry({ count: 5, delay: this.shouldRetry }),
      catchError(error => {
        if(error.status == 401) {
          return this.handre401Error(req, next);
        } 

        if(error.status >= 500) {
          this.notifyService.emitError("Falha na comunicação com o servidor. Tente novamente mais tarde");
        }

        if(error.status == 404) {
          this.notifyService.emitWarn("Dados não encontrados");
        }

        if(error.status != 422 && error.status != 404 && error.status != 412) {
          this.notifyService.emitError("Ocorreu um erro inesperado. Tente novamente mais tarde");
        }

        if(error.status == 422) {
          this.notifyService.emitError(error.error.detail);
        }

        return throwError(() => error);
    }))
  }

  private shouldRetry(error: HttpErrorResponse) {
    if (error.status === 0) {
      return timer(1000); 
    }

    throw error;
  }

  private handre401Error(req: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      let token = this.tokenService.getRefreshToken();
      const userId = Number.parseInt(<string>localStorage.getItem('userId'));
     const unitId = Number.parseInt(<string><string>localStorage.getItem('unitId'));

      return this.auth.authRefreshPOST({
        refreshToken: token,
        userId,
        unitId
      }).pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          localStorage.setItem('access_token', token.accessToken);
          localStorage.setItem('refresh_token', token.refreshToken);
          this.refreshTokenSubject.next(token.accessToken);
          return next.handle(this.setHeaderToken(req));
        }),
        catchError((err) => {
          this.isRefreshing = false;
          this.router.navigate(['login']);
          this.auth.logOut();
          return throwError(() => err);
        })
      )
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.setHeaderToken(req));
        })
      );
    }
  }

  setHeaderToken(req: any) {
    const userToken = this.tokenService.getToken()
    const realm = <string>localStorage.getItem('realm');
    const userId = <string>localStorage.getItem('userId');
    const unitId = <string>localStorage.getItem('unitId');
    return req.clone({
      headers: req.headers
        .set('Authorization', `Bearer ${userToken}`)
        .set('X-Keycloak-Realm', realm)
        .set('X-Keycloak-User', userId)
        .set('X-Keycloak-Unit', unitId)
    });
  }
}
